export const config = {
  title: "Love & Care LLC – Cleaning & Janitorial Services",
  meta: {
    description:
      "Love & Care LLC offers compassionate, detail-focused cleaning and janitorial services in Dayton, OH. We specialize in residential and commercial cleaning, ensuring every space is treated with care and precision.",
    keywords: [
      "Dayton cleaning services",
      "janitorial services Dayton",
      "residential cleaning Dayton",
      "commercial cleaning Dayton",
      "Love & Care LLC",
      "professional cleaning Dayton OH",
    ],
    author: "Love & Care LLC",
    canonicalUrl: "https://loveandcareclean.com/",
  },
  sections: {
    header: {
      businessName: "Love & Care LLC",
    },
    sectionB: {
      heroTitle: "A Cleaner Space, A Kinder Approach",
      heroSubtitle: "Professional Cleaning Services with a Personal Touch",
      learnAboutText: "Discover Our Services",
      phoneNumber: "9373538008",
      phoneLabel: "(937) 353-8008",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1877219986/photo/cleaner-is-mopping-floors-at-home-with-a-mop.jpg?s=612x612&w=0&k=20&c=sROlx2OHfsLi3TPCXTI-cxkiyueBqC3LH4xwBVK9jb4=", // Replace with actual image URL if available
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Transform your home into a sanctuary with our meticulous cleaning services tailored to your needs.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Maintain a pristine and professional environment with our comprehensive janitorial solutions.",
        },
        {
          title: "Window Cleaning",
          description:
            "Enhance your view with our streak-free window cleaning services, bringing clarity and brightness to your space.",
        },
      ],
      description:
        "At Love & Care LLC, we believe in delivering more than just cleanliness. Our dedicated team ensures every corner shines, providing peace of mind and a healthier environment for our clients in Dayton, OH.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive cleaning solutions designed to meet the unique needs of both residential and commercial clients.",
      cards: [
        {
          title: "Deep Cleaning",
          description:
            "Experience a thorough clean that reaches every nook and cranny, ensuring a refreshed and hygienic space.",
          imageSrc:
            "https://media.istockphoto.com/id/1279811110/photo/chemical-sofa-depth-cleaning-by-a-professional.jpg?s=612x612&w=0&k=20&c=LTXNDb6iPDLC8HfUGuyIp9qJd1awMGsFTKU3hPmxhsE=",
          imageAlt: "Deep Cleaning Service",
        },
        {
          title: "Routine Janitorial Services",
          description:
            "Keep your business premises spotless and welcoming with our regular cleaning schedules.",
          imageSrc:
            "https://media.istockphoto.com/id/1061588110/photo/cleaner-washes-a-mop-tiled-floors.jpg?s=612x612&w=0&k=20&c=m-uzvqig1Ox1IVK0lPXJubPw0wL8pNSiUmQTkAS8I6E=",
          imageAlt: "Routine Janitorial Services",
        },
        {
          title: "Move-In/Move-Out Cleaning",
          description:
            "Ensure a smooth transition with our detailed cleaning services tailored for moving in or out.",
          imageSrc:
            "https://media.istockphoto.com/id/623877874/photo/cardboard-boxes-and-cleaning-things-for-moving-into-new-home.jpg?s=612x612&w=0&k=20&c=mptfKUS4-TroMjmHMiAiWjfjzbhi-umseQmOZUprJ14=",
          imageAlt: "Move-In/Move-Out Cleaning",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Window Cleaning",
        "Carpet Cleaning",
        "Post-Construction Cleaning",
        "Customized Cleaning Plans",
        "Eco-Friendly Cleaning Options",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://our.uenicdn.com/image/upload/v1746399224/business/595d180e46204488a31059640ee4a6c5.jpg ", // Replace with actual image URL if available
        alt: "Love & Care LLC Team",
      },
      aboutText: [
        "Founded by Albert Mugiraneza, Love & Care LLC is rooted in the belief that cleaning services should be delivered with empathy and dedication.",
        "Our team is committed to providing exceptional cleaning solutions that not only meet but exceed our clients' expectations, fostering environments where they can thrive.",
      ],
    },
    sectionE: {
      profileImage: null, // Replace with actual image URL if available
      profileAlt: "Love & Care LLC Logo",
      businessName: "Love & Care LLC",
      contact: {
        phone: "9373538008",
        phoneLabel: "(937) 353-8008",
        email: "loveandcare@gmail.com",
        website: "https://loveandcareclean.com/",
        address: "228 Byers Rd, Suite 301, Miamisburg, OH 45342",
      },
      socialMedia: {
        facebook: null, // Replace with actual URL if available
        instagram: null, // Replace with actual URL if available
        twitter: null, // Replace with actual URL if available
        linkedin: null, // Replace with actual URL if available
        youtube: null, // Replace with actual URL if available
      },
    },
    sectionF: {
      address: "228 Byers Rd, Suite 301, Miamisburg, OH 45342",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3095.123456789!2d-84.2345678!3d39.6423456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8840b123456789ab%3A0xabcdef1234567890!2s228%20Byers%20Rd%2C%20Miamisburg%2C%20OH%2045342!5e0!3m2!1sen!2sus!4v1614123456789!5m2!1sen!2sus",
    },
  },
};

export default config;
